import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { layoutStyle } from "../pages/layout-ui/style";
import { onSortChanged } from "../common/utils/sortingColumn";

export const SortingTextPopup = ({
  open,
  setOpen,
  gridRef,
  setSortedColumn,
  setColumnFinal,
  columnFinal,
  sortableColumnData,
  createSortableColumn,
  updateViewSortableColumn,
  pageName,
}) => {
  const classes = layoutStyle();

  const handleClick = async () => {
    await onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      columnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      pageName
    );
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {sortableColumnData &&
          sortableColumnData?.length > 0 &&
          sortableColumnData[0]?.pageName === pageName
            ? `Do you want to override sorting on this page?`
            : `Do you want to override ${sortableColumnData[0]?.pageName} sorting ?`}
        </DialogTitle>
        <DialogActions>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteCancelButton}
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            type="submit"
            className={classes.deleteOkButton}
            onClick={handleClick}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
